import { createSvgComponent } from "../../icon/createSvgComponent";
import HeartFill from "@core/__generated__/icon/figma/heart-fill.svg";
export default createSvgComponent(HeartFill);